import React from 'react';
import { Image } from 'react-konva';
const pipeStubImgSrc = require('../../../../media/pipes/PipeAccessories/pipe-stub.png');

/* instantiate the image */
const image = new window.Image();
image.src = pipeStubImgSrc;

export default class PipeStubComponent extends React.Component {
  render() {
      return (
        <Image
          image={image}
          x={this.props.x}
          y={this.props.y}
          height={this.props.diameter}
          rotation={this.props.rotation}
          width={this.props.diameter*2.5}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/PipeAccesories/pipe-stub.component.js